/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import * as components from "../components/index.js";

export type PreviewEquipmentDetailsViewRequest = {
  /**
   * The id of the device to get the equipment details view for
   */
  deviceId: string;
  agentId: string;
  body: components.PreviewEquipmentBulkEditViewRequestBody;
};

/** @internal */
export type PreviewEquipmentDetailsViewRequest$Outbound = {
  device_id: string;
  agent_id: string;
  body: components.PreviewEquipmentBulkEditViewRequestBody$Outbound;
};

/** @internal */
export const PreviewEquipmentDetailsViewRequest$outboundSchema: z.ZodType<
  PreviewEquipmentDetailsViewRequest$Outbound,
  z.ZodTypeDef,
  PreviewEquipmentDetailsViewRequest
> = z.object({
  deviceId: z.string(),
  agentId: z.string(),
  body: components.PreviewEquipmentBulkEditViewRequestBody$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    deviceId: "device_id",
    agentId: "agent_id",
  });
});

export function previewEquipmentDetailsViewRequestToJSON(
  previewEquipmentDetailsViewRequest: PreviewEquipmentDetailsViewRequest,
): string {
  return JSON.stringify(
    PreviewEquipmentDetailsViewRequest$outboundSchema.parse(
      previewEquipmentDetailsViewRequest,
    ),
  );
}
